import React from 'react'
import Button from 'components/button'
import { validateSourceUrl } from 'helpers/utils'

interface IntegrationCardProps {
  provider: string
  logo: string
  connected: boolean
  connectingAccount: boolean
  disconnectAccount: (provider: string) => void
  children?: React.ReactNode
}

const IntegrationCard: React.FC<IntegrationCardProps> = ({
  provider,
  logo,
  connected,
  connectingAccount,
  disconnectAccount,
  children
}) => {
  return (
    <div
      data-testid={`integration-tile-${provider}`}
      className="flex flex-col items-center justify-between rounded-lg border border-divider bg-surface px-3 py-4 shadow-sm transition-shadow hover:shadow-md h-[150px]"
    >
      {/* Brand logos are drawn for a light page, and several are dark ink (Asite,
          Autodesk, Procore, Revizto), so in dark mode they sit on a white plate
          rather than being recoloured. */}
      <div className="flex w-full flex-1 items-center justify-center rounded-md px-2 dark:bg-white">
        <img src={validateSourceUrl(logo)} alt={provider} className="w-1/2 object-contain" />
      </div>

      <div className="mt-2.5 flex w-full min-w-0 items-center justify-center gap-1.5">
        {connected ? (
          <>
            <span className="inline-flex items-center rounded-full bg-light-green px-2 py-0.5 text-xs font-medium text-dark-green">
              Connected
            </span>
            <Button
              data-tour="integration-disconnect-account"
              internalType="danger"
              onClick={() => disconnectAccount(provider)}
              disabled={connectingAccount}
            >
              Disconnect
            </Button>
          </>
        ) : (
          children
        )}
      </div>
    </div>
  )
}

export default IntegrationCard
